export default "__VITE_ASSET__Cti5zyvG__"